import { combineReducers } from "redux";
import Auth from "./auth";
import booking from "./booking";
import Bidding from "./bidding";
import Car from "./car";
import Area from "./area";

export default combineReducers({
  Auth,
  booking,
  Bidding,
  Car,
  Area,
});



// WEBPACK FOOTER //
// src/store/reducers/index.js